import styled from 'styled-components'

export const HeaderWrappeer = styled.header`
  display:flex;
  max-width:1200px;
  margin:0 auto;
  padding:10px 20px;
  box-shadow:border-box;
  flex-wrap:wrap;
　background-color:#fff;
`